import { FeatureFlagEnum } from "@finway-group/shared/lib/models"
import { Switch } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { FINWAY_ADMIN_EMAIL } from "Shared/config/consts"
import { useAuth } from "Shared/hooks/auth.hooks"
import { useIsPurchaseRequestEnabled } from "Shared/hooks/featureFlags.hooks"
import { useUpdateTenantFeatureFlag } from "Shared/queries/tenant.queries"
import NotificationService, { NotificationTypeEnum } from "Shared/services/notification.service"

export const CsPurchaseRequestFeatureFlag = () => {
    const { t } = useTranslation()
    const { userClass } = useAuth()

    const [isLoading, setIsLoading] = useState(false)

    const isPurchaseRequestEnabled = useIsPurchaseRequestEnabled()
    const updateTenantFeatureFlag = useUpdateTenantFeatureFlag()

    if (userClass?.email !== FINWAY_ADMIN_EMAIL) {
        return null
    }

    const onTogglePurchaseRequestFeature = async () => {
        setIsLoading(true)

        updateTenantFeatureFlag.mutate(
            { featureFlag: FeatureFlagEnum.PURCHASE_REQUEST_ENABLED, isEnabled: !isPurchaseRequestEnabled },
            {
                onSuccess: async () => {
                    setIsLoading(false)
                },
                onError: (error) => {
                    setIsLoading(false)
                    NotificationService.send(NotificationTypeEnum.ERROR, t("error:error"), error?.toString())
                },
            },
        )
    }

    return (
        <div className="flex justify-between items-center mt-16">
            <span>{t("label:cs_feature_flags.purchase_requests")}</span>
            <Switch checked={isPurchaseRequestEnabled} onChange={onTogglePurchaseRequestFeature} loading={isLoading} />
        </div>
    )
}
